import React from "react";

const defaultBehavior = {};

const DialogContext = React.createContext(defaultBehavior);

export default DialogContext;
